/**
 * Extract merchant ID from hostname or return default
 * Handles subdomain-based merchant identification
 * @returns The identified merchant ID or 'demo' as fallback
 */
export const getMerchantIdFromHostname = (): string => {
  const hostname = window.location.hostname;
  // For mattressai.co subdomains, extract merchant ID from subdomain
  if (hostname.endsWith('.mattressai.co')) {
    const parts = hostname.split('.');
    if (parts.length >= 3) {
      return parts[0];
    }
  }
  // Add specific handling for known development/staging hostnames if needed
  // Example:
  // if (hostname.includes('localhost') || hostname.includes('pages.dev')) {
  //   return 'demo'; // Or a specific test ID
  // }
  
  return 'demo'; // Default merchant ID
}; 